module.exports = __webpack_public_path__ + "media/src/images/icons/gray-plus-63e4e8b6ee104adaf4e79caa189e97fd.svg";